const RECONNECT_MESSAGE_KEYS = new Set([
  'social.socialTokenExpiredRefreshOrReconnect',
  'social.socialAccountIsInactiveReconnectRequired',
  'social.socialAccountIsNotConnected',
  'social.socialAccountIsInactive',
  'social.metaAssetIdRequired',
  'social.platformOAuthExchangeFailed',
  'social.connectionNotConfigured',
  'social.platformIntegrationNotConfigured',
]);

const RECONNECT_TEXT_PATTERNS = [
  /token expired/i,
  /refresh or reconnect/i,
  /reconnect required/i,
  /reconnect in connection center/i,
  /not connected/i,
  /inactive.*reconnect/i,
  /meta asset/i,
  /oauth exchange failed/i,
  /integration not configured/i,
];

export function isSocialReconnectMessageKey(messageKey?: string | null): boolean {
  if (!messageKey?.trim()) return false;
  const key = messageKey.trim();
  if (RECONNECT_MESSAGE_KEYS.has(key)) return true;
  return key.startsWith('social.') && RECONNECT_TEXT_PATTERNS.some((p) => p.test(key));
}

export function isSocialReconnectRequiredMessage(message?: string | null): boolean {
  if (!message?.trim()) return false;
  const text = message.trim();
  if (isSocialReconnectMessageKey(text)) return true;
  return RECONNECT_TEXT_PATTERNS.some((pattern) => pattern.test(text));
}

export function isSocialReconnectRequired(err: unknown): boolean {
  if (err && typeof err === 'object') {
    const record = err as { message?: string; messageKey?: string; apiMessage?: string };
    if (isSocialReconnectMessageKey(record.messageKey)) return true;
    if (isSocialReconnectRequiredMessage(record.apiMessage)) return true;
    if (isSocialReconnectRequiredMessage(record.message)) return true;
  }
  if (typeof err === 'string') {
    return isSocialReconnectRequiredMessage(err);
  }
  return false;
}
